import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const boardBulkActionsStyleId = 'wb-v2-board-bulk-actions-theme';

export const boardBulkActionsBridgeStyles = {
  'board-bulk-actions': {
    '--local-board-bulk-actions-bg': tokens.color.background.primary,
    '--local-board-bulk-actions-border': tokens.color.border.primary,
    '--local-board-bulk-actions-shadow': `0 8px 18px rgba(16, 24, 40, 0.12), ${tokens.shadow.sm}`,
    '--local-board-bulk-actions-radius': tokens.radius.md,
  },
};
